$ = require 'jquery'
Announcements = require 'models/announcements'
Util = require 'lib/util'
_ = require 'underscore'

_.defer ->
  # Choose a random interval, to decrease the chances that we end up with many
  # clients requesting an announcements update at the same time
  interval = Util.getMs({ minutes: 10 + Math.random() * 5 })

  lastCheck = null

  # document.hasFocus may be unreliable, but we can try to use it for the
  # initial value
  hasFocus = document.hasFocus?() || true

  # Only check for updates if the window has the focus and enough time has
  # passed
  checkForUpdates = ->
    if hasFocus && (!lastCheck? || Date.now() - lastCheck > interval)
      Announcements.fetch()
      lastCheck = Date.now()

  $(window).on 'focus', (e) ->
    hasFocus = true
    checkForUpdates()

  $(window).on 'blur', (e) ->
    hasFocus = false

  # Periodically check for new announcements; use an interval less than actual
  # interval, so we don't end up waiting twice as long as we should
  setInterval(checkForUpdates, interval / 4)

  checkForUpdates()



// WEBPACK FOOTER //
// ./app/scripts/entry/update-announcements.coffee